'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import * as CustomPropTypes from '../../../constants/PropTypes';
import emptyFunction from 'react-utils/emptyFunction';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import ThinListing from 'ecosystem-marketplace-core/records/ThinListing';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
import * as RequestState from 'ecosystem-marketplace-core/constants/RequestState';
import { isFulfilled } from 'ecosystem-marketplace-core/utils/requestState';
import ResultCard from './ResultCard';

const ResultsGrid = ({
  className,
  isAdminPreview,
  onResultClick,
  requestState,
  resultProps,
  results
}) => {
  const renderedResults = useMemo(() => {
    return results.toArray().map((result, index) => {
      return /*#__PURE__*/_jsx(ResultCard, Object.assign({}, resultProps, {
        isAdminPreview: isAdminPreview,
        onClick: () => {
          onResultClick(result, index);
        },
        result: result
      }), result.id);
    });
  }, [isAdminPreview, onResultClick, resultProps, results]);
  const responsiveProps = useResponsiveProps({
    columns: {
      xs: 1,
      sm: 2,
      lg: 3
    }
  });

  if (!isFulfilled(requestState)) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      "data-selenium-id": "results-loading-spinner",
      grow: true,
      minHeight: 150,
      layout: "centered"
    });
  }

  return /*#__PURE__*/_jsx(UICardGrid, Object.assign({
    className: className,
    gutterSize: 16
  }, responsiveProps, {
    children: renderedResults
  }));
};

ResultsGrid.propTypes = {
  className: PropTypes.string,
  isAdminPreview: PropTypes.bool,
  onResultClick: PropTypes.func,
  requestState: CustomPropTypes.requestState,
  resultProps: PropTypes.object,
  results: ImmutablePropTypes.iterableOf(PropTypes.instanceOf(ThinListing)).isRequired
};
ResultsGrid.defaultProps = {
  onResultClick: emptyFunction,
  resultProps: {},
  requestState: RequestState.SUCCEEDED
};
export default ResultsGrid;